import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IFilterView, IPaginatorView, ISortView, PaginatorState, SortState} from "../crud-table";
import {HttpClient} from "@angular/common/http";
import {SweetAlertService} from "../shared/services/common/sweet-alert.service";
import {debounceTime} from "rxjs/operators";

@Component({
    selector: 'app-base-crud-pages',
    template: ``,
    styles: [],
})

export class BaseCrudPagesComponent implements OnInit, OnDestroy, ISortView, IFilterView, IPaginatorView {
    isLoading: boolean;
    public subscriptions: Subscription[] = [];
    filterGroup: FormGroup;
    sorting: SortState;
    paginator: PaginatorState;
    arrFormGroups: any[] = [];
    protected http: HttpClient;
    arrFilterForm = [];

    constructor(
        @Inject('') protected tableService: any,
        protected fb: FormBuilder
    ) {}

    paginate(paginator: PaginatorState) {
        this.tableService.patchState({ paginator });
    }

    // OVERRIDE THIS FOR FILTER
    filterForm() {
      let objTemp = new Object();
      this.arrFilterForm.forEach((el) => {
        objTemp[el] = [''];
      });
      this.filterGroup = this.fb.group(objTemp);

      this.arrFilterForm.forEach((el) => {
        this.subscriptions.push(
          this.filterGroup.controls[el].valueChanges
              .pipe(debounceTime(900))
              .subscribe(() =>
            this.filter()
          )
        );
      });
    }

    // OVERRIDE THIS FOR FILTER
    filter() {
      const filter = {};
      this.arrFilterForm.forEach((el) => {
        if (this.filterGroup.controls[el].value) {
          filter[el] = this.filterGroup.controls[el].value
        }
      });
      this.tableService.patchState({ filter });
    }

    sort(column: string): void {
        const sorting = this.sorting;
        const isActiveColumn = sorting.column === column;
        if (!isActiveColumn) {
            sorting.column = column;
            sorting.direction = 'asc';
        } else {
            sorting.direction = sorting.direction === 'asc' ? 'desc' : 'asc';
        }
        this.tableService.patchState({ sorting });
    }

    ngOnInit(): void {
        this.tableService.setDefaults();
        this.filterForm();
        this.tableService.fetch();
        const sb = this.tableService.isLoading$.subscribe(res => this.isLoading = res);
        this.tableService.errorMessage$.subscribe((res) => {
            if (typeof res == 'object') {
                if (res.hasOwnProperty('error')) {
                    SweetAlertService.swalError(res);
                }
            }
        })
        this.subscriptions.push(sb);
        this.sorting = this.tableService.sorting;
        this.paginator = this.tableService.paginator;
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sb) => sb.unsubscribe());
    }
}
